module.exports = __webpack_public_path__ + "static/media/chemistery.6cebc24f.png";